import { ConditionsNew, PackageType } from '@retail/calculus/types';
import { HierarchyLevels } from '@retail/products/types';
import { Filter, filterList } from '@shared/utils';

interface ConditionFilters {
  hierarchyLevel?: HierarchyLevels | PackageType | null;
  itemSearchQuery?: string | null;
}

export const matchesItemSearch = (condition: ConditionsNew, query: string): boolean => {
  if (condition.bindingType !== 'MG_SUPPLIER_ITEM') return false;

  const normalizedQuery = query.trim().toLowerCase();
  const { bindingTargetName, bindingTargetItem } = condition;

  return [
    bindingTargetName,
    bindingTargetItem?.mgItemNumber,
    bindingTargetItem?.supplierItemId,
    bindingTargetItem?.gtinCode,
  ]
    .filter((value) => value !== undefined && value !== null)
    .some((value) => String(value).toLowerCase().includes(normalizedQuery));
};

export const filterConditions = (
  conditions: ConditionsNew[],
  { hierarchyLevel, itemSearchQuery }: ConditionFilters
): ConditionsNew[] => {
  const filters: Filter<ConditionsNew>[] = [
    {
      active: !!hierarchyLevel,
      predicate: (condition) =>
        condition.bindingType === hierarchyLevel ||
        condition.bindingTargetItem?.packageType === hierarchyLevel,
    },
    {
      active: !!itemSearchQuery?.trim(),
      predicate: (condition) => matchesItemSearch(condition, itemSearchQuery ?? ''),
    },
  ];

  return filterList({ filters, initList: conditions });
};
